import React from "react";

import { Title } from "..";
import "./whyChooseUs.css";

const reasons = [
  {
    number: "01",
    title: "Learn by doing",
    text: "Build practical projects that turn new ideas into real-world skills you can apply with confidence.",
  },
  {
    number: "02",
    title: "Mentorship that fits",
    text: "Get guidance tailored to your goals, pace, and starting point so you always know the next step.",
  },
  {
    number: "03",
    title: "Skills for the future",
    text: "Learn digital capabilities that matter in school, work, business, and everyday problem solving.",
  },
  {
    number: "04",
    title: "Career-ready training",
    text: "Explore learning paths designed to help you grow into modern opportunities in tech and innovation.",
  },
  {
    number: "05",
    title: "Supportive community",
    text: "Join a learning environment where curiosity is encouraged, questions are welcome, and progress is celebrated.",
  },
  {
    number: "06",
    title: "Flexible learning",
    text: "Access practical, engaging lessons that fit around your schedule and help you keep moving forward.",
  },
];

const WhyChooseUs = () => {
  return (
    <section className="why-choose-us py-1" aria-label="Why choose us">
      <div className="container">
        <Title
          title="Why choose us?"
          subtitle="A practical path from curiosity to capability"
        />
        <div className="why-choose-us-grid">
          {reasons.map((reason) => (
            <article className="why-choose-us-card" key={reason.number}>
              <span className="why-choose-us-number">{reason.number}</span>
              <h3>{reason.title}</h3>
              <p>{reason.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
